import dayjs from 'dayjs';

/** Default to month-to-date for partner performance reports. */
export const getDefaultPerformanceReportRange = () => [
  dayjs().startOf('month'),
  dayjs().endOf('day'),
];

export const toPerformanceReportPayload = (dateRange) => ({
  start_date: dateRange[0].format('YYYY-MM-DD'),
  end_date: dateRange[1].format('YYYY-MM-DD'),
});

export const buildPerformanceReportFilename = (partnerName, startDate, endDate) => {
  const slug = String(partnerName || 'partner')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 40);
  return `partner-performance-${slug}-${startDate}-${endDate}.pdf`;
};

export const triggerPdfDownload = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
